import { AfterViewInit, Component, computed, ElementRef, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SocialsComponent } from "./socials/socials.component";
import { GlobalConstants } from "src/app/common/global";
import { ModalNames } from "src/app/common/modal.config";
import { ModalService } from "src/app/services/modal.service";
import { ProfileService } from "src/app/services/profile.service";
import { Router, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'app-promo-video',
  standalone: true,
  imports: [TranslateModule, SocialsComponent, RouterModule, CommonModule],
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.sass']
})
export class PromoVideoComponent implements AfterViewInit {
  @ViewChild('promoVideo', { static: true }) promoVideoRef?: ElementRef<HTMLVideoElement>;
  isMembershipModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Membership) ?? false);
  isLogged: boolean = false;
  userHasMembership: boolean = true;
  public readonly modalNamesEnum = ModalNames;

  constructor(
    private modalService: ModalService,
    private profileService: ProfileService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isLogged = GlobalConstants.isAuth;

    if(this.isLogged) {
      this.profileService.getMemberships(true).subscribe({    
        next: (data) => {
          const response: any = data;
          this.userHasMembership = (response.data.own || response.data.others.length > 0) ? true : false;
          
          if(!this.userHasMembership && sessionStorage.getItem("openModal") === "membership") {
            this.modalService.openModal(this.modalNamesEnum.Membership);
            sessionStorage.removeItem("openModal");
          } else if(sessionStorage.getItem("openModal") === "membership") {
            sessionStorage.removeItem("openModal");
            this.router.navigate(["/membership-profile"]);
          }
        }
      });
    } else {
      this.userHasMembership = false;
    }
  }
  
  ngAfterViewInit(): void {
    const videoElement = this.promoVideoRef?.nativeElement;
    if (videoElement) {
      videoElement.muted = true;
      videoElement.playsInline = true;
      videoElement.autoplay = true;
      videoElement.loop = true;

      if (!videoElement.isConnected) {
        return;
      }

      videoElement.play().catch();
    }
  }

  openMembershipModal() {
    if(this.isLogged) {
      this.modalService.openModal(this.modalNamesEnum.Membership); 
    } else {
      this.modalService.openModal(this.modalNamesEnum.Login);
      sessionStorage.setItem("openModal", "membership");
    }
  }
}